export const ExperimentNames = {
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EditTicketPDF: 'specs.events.ui.EditTicketPDF',
    PageInstallFlow: 'specs.events.ui.PageInstallFlow',
    PublishedListTips: 'specs.events.PublishedListTips',
    PricingPlansEventsFlexiForm: 'specs.events.ui.PricingPlansEventsFlexiForm',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
    MessagesNewDesign: 'specs.events.ui.MessagesNewDesign',
    RsvpDynamicMessages: 'specs.events.ui.RsvpDynamicMessages',
    RicosBusinessManager: 'specs.events.ui.Ricos',
    StaffPage: 'specs.events.ui.Staff',
    ZeroPricingOption: 'specs.events.ui.ZeroPricingOption',
    ZeroInsteadOfFree: 'specs.events.ui.ZeroInsteadOfFree',
    ListLayoutDateStyle: 'specs.events.ui.ListLayoutDateStyle',
    DateAndLocationSettings: 'specs.events.ui.DateLocationSettings',
    TempFixRecurringEvents: 'specs.events.TempFixRecurringEvents',
    SausageIntegration: 'specs.events.ui.SausageIntegration',
    ReuseTicketsDesign: 'specs.events.ui.ReuseTicketsDesign',
    DateTimeImprovements: 'specs.events.ui.DateTimeImprovements',
    GuestListTicketTypeFilter: 'specs.events.ui.GuestListTicketTypeFilter',
    LinksColorSetting: 'specs.events.ui.LinksColorSetting',
    TicketDefinitionsLimitReachedWarning: 'specs.events.ui.TicketDefinitionsLimitReachedWarning',
    RemoveUnnecessaryBmRequests: 'specs.events.ui.RemoveUnnecessaryBmRequests',
    StaticMapIntegration: 'specs.events.ui.StaticMapIntegration',
    CategoriesImprovement: 'specs.events.ui.CategoriesImprovement',
    RemoveLiveVideoAccess: 'specs.events.ui.RemoveLiveVideoAccess',
    EnablePromoterDevCenterMigration: 'specs.wosbm.migrate-promote-marketing-tools-to-devcenter',
    SeatingCardABC: 'specs.events.ui.SeatingCardABC',
    SingleEventMobileSizing: 'specs.events.ui.SingleEventMobileSizing',
    UpdatedClassicAddPanel: 'specs.events.ui.UpdatedClassicAddPanel',
    PapyrusPreviewSiteLanguage: 'specs.events.ui.PapyrusPreviewSiteLanguage',
    EventsLimitWarning: 'specs.events.ui.EventsLimitWarning',
    HoppEntryPoint: 'specs.events.ui.HoppEntryPoint',
    LibraryBasedIOD: 'specs.events.ui.LibraryBasedIOD',
    UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
    UpdatePaymentTermsSquare: 'specs.events.ui.UpdatePaymentTermsSquare',
    RecurringEventsImprovements: 'specs.events.ui.RecurringEventsImprovements',
    NewReservationsService: 'specs.events.ui.NewReservationsService',
    NewReservationsServiceBM: 'specs.events.ui.NewReservationsServiceBM',
    CheckInBanner: 'specs.events.ui.CheckInBanner',
    DonationInputFix: 'specs.events.ui.DonationInputFix',
    EventPresets: 'specs.events.ui.EventPresets',
};
//# sourceMappingURL=experiments.js.map